var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('van-popup', {
    attrs: {
      "round": "",
      "close-on-click-overlay": false,
      "closeable": "",
      "position": "bottom",
      "close-icon": ""
    },
    on: {
      "click-overlay": function ($event) {
        return _vm.handleClose();
      }
    },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }, [_c('div', {
    staticClass: "popuo_box"
  }, [_c('div', {
    staticClass: "popuo_box_header"
  }, [_c('div', {
    staticClass: "lefttitle"
  }, [_vm._t("lefttitle")], 2), _c('p', [_vm._v(_vm._s(_vm.contentTitle))]), _vm.isCloseIcon ? _c('img', {
    staticClass: "close_icon",
    attrs: {
      "src": require("@/assets/image/ic_xxxxxx.png"),
      "alt": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleClose();
      }
    }
  }) : _vm._e()]), _vm._t("content")], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };